import { useEffect, useState } from "react";

import { db } from "../firebase/config";
import { sortBy } from "lodash";

const useComments = (collection: string, collectionID?: string) => {
  const [comments, setComments] = useState<any>([]);

  useEffect(() => {
    const extractComment = async (commentID: string, data: any) => {
      const { message, user } = data;
      const time = data.time.toDate();
      const userID = user.id;
      const profileRef = await db.collection("profiles").doc(userID).get();
      const profileData = profileRef.data();

      const replies = await Promise.all(
        (data.replies || []).map(async (reply: any, key: number) => {
          return await extractComment(commentID, reply);
        })
      );

      return {
        commentID,
        message,
        time,
        user: {
          ...profileData,
          ID: userID,
        },
        replies,
      };
    };

    if (collection && collectionID) {
      db.collection("comments")
        .where("collection", "==", collection)
        .where("collectionID", "==", collectionID)
        .onSnapshot(async (qs) => {
          const comments = await Promise.all(
            qs.docs.map(async (doc) => {
              const data = doc.data();
              return extractComment(doc.id, data);
            })
          );

          setComments(sortBy(comments, ["time"]));
        });
    }
  }, [collection, collectionID]);

  return comments;
};

export default useComments;
